import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';

import ReactFlagsSelect from "react-flags-select";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import { FaAngleLeft } from 'react-icons/fa6'
import chooseCardIcon from '../../../../assets/img/icon/card_icon3.png';
import { toast } from 'react-toastify';
import CardsProgressSteps from '../../../../components/ProgressStep/CardsProgressSteps'
import { useSelector, useDispatch } from 'react-redux';
import { validateVirtualCardCreation } from '../../../../api/api';
import { initializeFunding } from '../../../../actions/payments';
import { fetchExchangeRates } from "../../../../redux/slices/countriesSlice";

// Register the locale
countries.registerLocale(enLocale);

// Generate a mapping of country codes to their full names
const countryNames = countries.getNames("en", { select: "official" });

// const cardOptions = [
//     { id: 1, slug: "verve", name: "NGN Verve Card", currencyCode: "NGN", countryCode: "NG" },
//     { id: 2, slug: "mastercard", name: "USD Mastercard", currencyCode: "USD", countryCode: "US" },
//     { id: 3, slug: "visa", name: "USD VISA Card", currencyCode: "USD", countryCode: "US" },
// ];


const FundCard = ({ userDetails }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    
    const storedCardDetails = location.state?.customizedCardDetails;

    // const defaultCard = userDetails?.countryCode === "NG" 
    //     ? cardOptions.find(card => card.slug === "verve") 
    //     : cardOptions.find(card => card.slug === "mastercard");

    console.log("Step 3", location.state);

    const prevPayload = location.state?.creationPayload;

    const [paymentSource, setPaymentSource] = useState("");
    const [amount, setAmount] = useState(location.state?.amountFunded || "");
    const [address, setAddress] = useState(prevPayload?.address || userDetails?.address || "");
    const [city, setCity] = useState(prevPayload?.city || userDetails?.city || "");
    const [stateRegion, setStateRegion] = useState(prevPayload?.state || userDetails?.province || userDetails?.state || "");
    const [postalCode, setPostalCode] = useState(prevPayload?.postal_code || userDetails?.postal_code || "");
    const [isEdited, setIsEdited] = useState(!!location.state?.amountFunded);
    const [allWallets, setAllWallets] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [selectedCard, setSelectedCard] = useState(defaultCard?.name || ""); 
    const defaultWalletBalance = userDetails?.default_wallet?.balance
    const defaultWalletCurrency = userDetails?.default_wallet?.currency_code || "NGN";
    const fee_configurations = storedCardDetails?.fee_configurations || [];
    const supported_countries = storedCardDetails?.supported_countries || [];

    const [selectedCountry, setSelectedCountry] = useState(prevPayload?.iso2_country_code || userDetails?.countryCode || "NG");
    
    const { allowedCountries, currencyOptions, conversionRates } = useSelector((state) => state.country);
    
    // const customLabels = Object.fromEntries(
    //     currencyOptions
    //       .filter(option => allowedCountries.includes(option.countryCode.toUpperCase()))
    //       .map(option => [option.countryCode, option.currencyCode])
    // );

    const customLabels = Object.fromEntries(
        (currencyOptions || [])
            .filter(option => option?.countryCode && (allowedCountries || []).includes(option.countryCode.toUpperCase()))
            .map(option => {
                const countryName = countryNames[option.countryCode] || option.countryCode;
                return [
                    option.countryCode,
                    `${countryName} (${option.currencyCode})`
                ];
        })
    );

    useEffect(() => {
        dispatch(fetchExchangeRates());
    }, [dispatch]);

    // useEffect(() => {
    //     if (defaultCard) {
    //         setSelectedCountry(defaultCard.countryCode);
    //     }
    // }, [defaultCard]);
    
    const findRate = (from, to) => {
        if (from === to) return 1;

        const fromData = (conversionRates || []).find(r => r.currency_code === from);
        const toData = (conversionRates || []).find(r => r.currency_code === to);

        if (!fromData || !toData) return 0;

        const fromBuyRate = parseFloat(fromData.buy_rate);
        const toSellRate = parseFloat(toData.sell_rate);

        return parseFloat((toSellRate / fromBuyRate).toFixed(3));
    };

    const getCurrencyInfoByCountryCode = (code) => {
        return (currencyOptions || []).find(c => c.countryCode === code) || {};
    };

    let localToUSD = 0;
    let fundingAmount = 0;
    let equivalentAmount = 0;
    
    const selectedCurrencyDetails = getCurrencyInfoByCountryCode((selectedCountry || "NG").toUpperCase());
    const currencyCode = defaultWalletCurrency;
    
    // Check if user's default wallet matches primary currency of supported countries
    let buyRate = 1;
    const walletRateData = (conversionRates || []).find(r => r.currency_code === defaultWalletCurrency);
    if (walletRateData) {
        buyRate = parseFloat(walletRateData.buy_rate);
    } else {
        buyRate = findRate("USD", currencyCode);
    }

    const exchangeRate = buyRate;
    const currencySymbol = selectedCurrencyDetails?.symbol || "$";
    
    // Calculate dynamic fees
    const createConfigs = fee_configurations.filter(f => f.card_action === 'create');
    
    let computedCreationFee = 0;
    if (createConfigs.length > 0) {
        createConfigs.forEach(config => {
            if (config.fee_type === 'flat' || config.fee_type === 'hybrid') {
                computedCreationFee += parseFloat(config.flat_fee_amount || 0);
            }
        });
    }

    let fundingFee = 0;
    
    const inputAmount = parseFloat(amount) || 0;

    if (inputAmount > 0) {
        const fundConfigs = fee_configurations.filter(f => f.card_action === 'fund');
        if (fundConfigs.length > 0) {
            fundConfigs.forEach(config => {
                const min = config.minimum_amount !== null ? parseFloat(config.minimum_amount) : 0;
                const max = config.maximum_amount !== null ? parseFloat(config.maximum_amount) : Infinity;
                
                if (inputAmount >= min && inputAmount <= max) {
                    if (config.fee_type === 'flat' || config.fee_type === 'hybrid') {
                        fundingFee += parseFloat(config.flat_fee_amount || 0);
                    }
                    if (config.fee_type === 'percentage' || config.fee_type === 'hybrid') {
                        fundingFee += (inputAmount * parseFloat(config.fee_percentage || 0)) / 100;
                    }
                }
            });
        }

        // Assuming inputAmount is in the card's currency (e.g. USD)
        fundingAmount = inputAmount; 
        const totalFee = computedCreationFee + fundingFee;
        const totalCardCurrency = fundingAmount + totalFee;
        
        equivalentAmount = (totalCardCurrency * exchangeRate).toFixed(2); // Convert back to wallet currency
    }

    const handlePaymentSourceChange = (e) => {
        setPaymentSource(e.target.value);
        setIsEdited(true);
    };
    
    const handleAmountChange = (e) => {
        setAmount(e.target.value);
        setIsEdited(true);
    };

    const handleGoBack = () => {
        navigate("/user/cards/step2", { 
            state: { 
                selectedCardData: location.state?.selectedCardData,
                nickname: storedCardDetails?.nickname,
                cardTheme: storedCardDetails?.cardTheme
            } 
        });
    };
      

    const handleContinue = async () => {
        const inputAmt = parseFloat(amount) || 0;
        if (inputAmt <= 0) {
            toast.error("Enter a valid amount", {
                toastId: "amount-fail-toast",
                className: "custom-toast",
            });
            return;
        }

        // navigate("/user/cards/billing_address", {
        //     state: {
        //         amountFunded: inputAmt,
        //         customizedCardDetails: storedCardDetails,
        //         creationPayload: {
        //             ...prevPayload,
        //             address,
        //             city,
        //             state: stateRegion,
        //             postal_code: postalCode,
        //             iso2_country_code: selectedCountry
        //         }
        //     }
        // });

        setLoading(true);
        try {
            const cardCurrency = storedCardDetails?.cardCurrency;
            const payload = {
                nickname: storedCardDetails?.nickname,
                card_type: storedCardDetails?.cardType || 'virtual',
                card_brand: storedCardDetails?.cardSlug,
                card_currency: cardCurrency,
                funding_amount: parseFloat(amount),
                expected_monthly_volume: storedCardDetails?.expectedMonthlyVolume,
                account_purpose: storedCardDetails?.accountPurpose,
            };

            const response = await validateVirtualCardCreation(payload);
            const validationData = response.data?.data || {};

            navigate("/user/cards/review_card", {
                state: {
                    amountFunded: parseFloat(amount),
                    validationData: validationData,
                    creationPayload: payload,
                    customizedCardDetails: storedCardDetails
                }
            });
        } catch (error) {
            let errorMsg = "Validation failed. Please try again.";
            if (error.response?.data?.message) {
                errorMsg = error.response.data.message;
                if (error.response.data.errors) {
                    const firstErrorKey = Object.keys(error.response.data.errors)[0];
                    if (firstErrorKey) {
                        errorMsg = error.response.data.errors[firstErrorKey][0];
                    }
                }
            }
            toast.error(errorMsg, {
                toastId: "validation-error-toast",
                className: "custom-toast",
            });
        } finally {
            setLoading(false);
        }
    }
  return (
    <section className='create__card__page card__fund__page pt-4'>
        <div className="d-flex align-items-center mb-4 px-md-3">
            <button 
                onClick={handleGoBack} 
                className="btn btn-light d-flex align-items-center shadow-sm" 
                style={{ 
                    borderRadius: '20px', 
                    padding: '6px 16px',
                    backgroundColor: '#ffffff',
                    border: '1px solid #E0E4EC',
                    color: '#19064B',
                    fontWeight: '500',
                    fontSize: '13px',
                    gap: '6px'
                }}
            >
                <FaAngleLeft size={13} />
                <span>Go back</span>
            </button>
        </div>

        <section><CardsProgressSteps currentStep={3} /></section>
        

        <section className="create-card_section funding__card__section pt-5">
            <div className="container">
                <div className='create_card_header'>
                    {/* <div className="d-flex align-items-center gap-3 ps-1 ps-md-4">
                        <img src={chooseCardIcon} alt="icon" width="30px" height="30px" className='img-fluid' />
                        <h4 className='mb-0'>Card Funding</h4>
                    </div> */} 
                </div>

                <div className="funding__form mx-auto" style={{ maxWidth: '480px' }}>
                    <div className="form__card-section p-4 bg-white shadow-sm" style={{ borderRadius: '24px', border: '1px solid #E0E4EC' }}>
                        
                        <div className="mb-4">
                            <label className="form-label fw-medium text-muted mb-2" style={{ fontSize: '13px' }}>Selected Card</label>
                            <div className="p-3 d-flex align-items-center justify-content-between" style={{ backgroundColor: '#F8F9FA', borderRadius: '16px', border: '1px solid #E0E4EC' }}>
                                <div className="d-flex align-items-center gap-3">
                                    <div style={{ width: '45px', height: '45px', backgroundColor: '#e9ecef', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src={chooseCardIcon} alt="card icon" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                                    </div>
                                    <div>
                                        <h6 className="mb-0 fw-semibold" style={{ color: '#19064B', fontSize: '15px' }}>{storedCardDetails?.cardName || "Virtual Card"}</h6>
                                        <p className="mb-0 text-muted mt-1" style={{ fontSize: '12px' }}>{storedCardDetails?.slug?.toUpperCase() || "VISA"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label fw-medium text-muted mb-2" style={{ fontSize: '13px' }}>Amount to Fund <span className="text-danger">*</span></label>
                            <div className="input-group" style={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid #E0E4EC', backgroundColor: '#ffffff', transition: 'all 0.2s' }}>
                                <span className="input-group-text bg-white border-0" style={{ padding: '0 15px' }}>
                                    <span className="fw-bold" style={{ color: '#19064B', fontSize: '16px' }}>
                                        {storedCardDetails?.cardCurrency}
                                    </span>
                                </span>
                                <input
                                    type="number"
                                    className="form-control border-0 fw-bold"
                                    placeholder="0.00"
                                    value={amount}
                                    onChange={handleAmountChange}
                                    min="1"
                                    style={{ fontSize: '22px', color: '#19064B', boxShadow: 'none', padding: '15px 15px 15px 0' }}
                                />
                            </div>
                        </div>

                        <div className="transaction-details p-4 mt-4" style={{ backgroundColor: '#F8F9FA', borderRadius: '16px', border: '1px solid #f1f3f5' }}>
                            <div className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
                                <span className="text-muted fw-medium" style={{ fontSize: '13px' }}>Exchange Rate</span>
                                <span className="fw-semibold" style={{ fontSize: '13px', color: '#19064B' }}>1 USD = {exchangeRate} {currencyCode}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <span className="text-muted fw-medium" style={{ fontSize: '13px' }}>Card Creation Fee</span>
                                <span className="fw-semibold" style={{ fontSize: '13px', color: '#19064B' }}>${computedCreationFee.toFixed(2)}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
                                <span className="text-muted fw-medium" style={{ fontSize: '13px' }}>Funding Fee</span>
                                <span className="fw-semibold" style={{ fontSize: '13px', color: '#19064B' }}>${fundingFee.toFixed(2)}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <span className="text-muted fw-medium" style={{ fontSize: '13px' }}>Total Card Amount</span>
                                <span className="fw-bold" style={{ fontSize: '14px', color: '#19064B' }}>{(fundingAmount + computedCreationFee + fundingFee).toFixed(2)} USD</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-3 pt-3" style={{ borderTop: '2px dashed #E0E4EC' }}>
                                <span className="text-muted fw-medium" style={{ fontSize: '14px' }}>Equivalent Amount</span>
                                <span className="fw-bold" style={{ fontSize: '16px', color: '#0A95FF' }}>{equivalentAmount} {currencyCode}</span>
                            </div>
                        </div>

                        <div className="mt-5">
                            <button onClick={handleContinue} className="btn w-100 py-3 fw-semibold text-white shadow-sm" disabled={!amount || loading} style={{ backgroundColor: '#0A95FF', borderRadius: '14px', fontSize: '15px', transition: 'all 0.3s' }}>
                                {loading ? (
                                    <><span className="spinner-border spinner-border-sm me-2"></span>Validating...</>
                                ) : "Continue"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </section>
  )
}

export default FundCard